export const tf = {
  companyName: 'FlySync',
  corporateName: 'Trailfinder',
  title: 'Trailfinder',
  templateConfig: 'template1',
  email: 'res@trailfinder.in',
  phone: '022 4085 4085 (10:00AM to 10:00PM)',
  address:
    '<div>1 & 2, 94- Dinath Building,<br/> Veer Savarkar Marg, Old Cadel Rd, <br/>next to Bilabong Internation School, Mahim West, Mumbai, Maharashtra 400016.</div>',
  apiUrl: 'https://b2btrailfinder.com/backend/',
  isFullBGimage: 'Y',
  loginBanner: 'N',
  whatsapp: '+91 7506710849',
  poweredBy: 'false',
  agentNavigate: 'https://b2btrailfinder.com/',
  instagram: '',
  facebook: '',
  twitter: '',
  linkedin: '',
  youtube: '',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['TJ'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
  recentSearch: 'N',
  encryptionSecretKey: 'd1e622507595486ee06db24b1debf11064edd2ba',
};
